// extracted by mini-css-extract-plugin
export default {"relationType":"relationTypeCell_relationType__ZnSF9"};